module.exports = __webpack_public_path__ + "files/786ead0a92ddb547f5a60257437b82bd.png";